<template>
  <ThemeDefaultContainerSection
    :description="modelValue.description"
    :title="modelValue.title"
    title-underline
    :see-more-path="getPath({ componentName: 'Product' })"
    :menu-code="MENU_CODE.PRODUCT"
    see-more-class="tw-mt-0"
    :event-name="eventName"
  >
    <div
      class="tw-grid tw-grid-cols-2 tw-gap-6 tw-mt-8 lg:tw-mt-12 tw-pt-2 lg:tw-grid-cols-4"
    >
      <div
        v-for="item in modelValue.content"
        :key="item._id"
      >
        <ThemeDefaultCardProduct
          title-tag="h3"
          :image="item.imageCover"
          :title="item.title"
          :path="getPath({ componentName: 'Product', slug: item.slug })"
          :category="{
            _id: item.productCategory?._id,
            title: item.productCategory?.title || '',
            slug: item.productCategory?.slug || '',
            path: getPath({ componentName: 'Product', categorySlug: item.productCategory?.slug || '' }),
          }"
          :options="item.options"
          :show-option-list="false"
          :price="item.price"
          :price-of-discounted="item.priceOfDiscounted"
          :min-price-option="item.minPriceOption"
          :max-price-option="item.maxPriceOption"
          :min-price-of-discounted-option="item.minPriceOfDiscountedOption"
          :max-price-of-discounted-option="item.maxPriceOfDiscountedOption"
          @click="eventHomeProduct(item.title)"
        />
      </div>
    </div>
  </ThemeDefaultContainerSection>
</template>

<script setup lang="ts">
// Props
const props = defineProps({
  modelValue: {
    type: Object as () => HomeSection<Product[]>,
    required: true,
  },
})

const { MENU_CODE, eventName, eventHomeProduct, getPath } = useProductSection()
</script>

<style scoped>
/* Hide the scrollbar for better UX */
.tw-scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.tw-scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
